import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/Header/Header';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import { apiConfig } from '../../lib/apiConfig';
import './PublicationList.css';

export default function PublicationList() {
  const [publications, setPublications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchPublications() {
      setLoading(true);
      setError(null);
      try {
        const res = await fetch(`${apiConfig.publicationBase}/publications?published=true&sort=publishedAt&dir=desc`);
        const data = await res.json();
        if (data && data.success && Array.isArray(data.items || data.data)) {
          setPublications(data.items || data.data);
        } else {
          setError('Aucune publication trouvée');
        }
      } catch (e) {
        setError('Erreur lors du chargement');
      } finally {
        setLoading(false);
      }
    }
    fetchPublications();
  }, []);

  if (loading) return <div>Chargement…</div>;
  if (error) return <div style={{color:'#b91c1c',padding:16}}>{error}</div>;

  return (
    <div>
      <Header />
      <Navbar />
      <div className="publication-list container card">
        <h2>Publications</h2>
        <ul style={{padding:0, listStyle:'none'}}>
          {publications.map(pub => (
            <li key={pub.id || pub._id} style={{marginBottom:24, borderBottom:'1px solid #e2e8f0', paddingBottom:16}}>
              <h3 style={{margin:'8px 0'}}>{pub.title}</h3>
              <div style={{color:'#64748b', fontSize:13, marginBottom:6}}>
                {pub.category && <span style={{marginRight:8}}>{pub.category}</span>}
                {pub.publishedAt && <span>Publié le {new Date(pub.publishedAt).toLocaleDateString()}</span>}
              </div>
              <div style={{marginBottom:8, color:'#334155'}}>
                {(pub.body || pub.description || '').replace(/<[^>]+>/g,' ').slice(0, 180)}…
              </div>
              <Link to={`/publications/${pub.id || pub._id}`} className="btn btn-secondary">Voir la publication</Link>
            </li>
          ))}
        </ul>
      </div>
      <Footer />
    </div>
  );
}
